import { apiClient } from '../lib/api';

export interface PaymentLink {
  id: string;
  storeId: string;
  title: string;
  amount: number | string;
  referenceCode: string;
  status: 'ACTIVE' | 'PAUSED' | 'EXPIRED' | 'ARCHIVED';
  clickCount: number;
  paymentCount: number;
  paidAmount: number | string;
  productId: string | null;
  expiresAt: string | null;
  customerName?: string | null;
  customerPhone?: string | null;
  createdAt: string;
  updatedAt: string;
}

export const fetchPaymentLinks = async (): Promise<PaymentLink[]> => {
  const response = await apiClient.get<any>('/merchant/payment-links');
  return response;
};

export interface CreatePaymentLinkPayload {
  title: string;
  amount: number | string;
  referenceCode?: string;
  expiresAt?: string;
  productId?: string;
  customerName?: string;
  customerPhone?: string;
}

export const createPaymentLink = async (payload: CreatePaymentLinkPayload): Promise<PaymentLink> => {
  const response = await apiClient.post<any>('/merchant/payment-links', payload);
  return response;
};

export const updatePaymentLinkStatus = async (id: string, status: 'ACTIVE' | 'PAUSED' | 'EXPIRED' | 'ARCHIVED'): Promise<PaymentLink> => {
  const response = await apiClient.patch<any>(`/merchant/payment-links/${id}/status`, { status });
  return response;
};
